import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { legShape } from 'constants/propTypes';

import { StyledJourneySummary } from 'components/shared/JourneyDigest/JourneyDigest.styles';
import ExchangeSummaryHeader from './ExchangeSummaryHeader/ExchangeSummaryHeader';
import ExchangeSummaryContainer from './ExchangeSummaryContainer';

import { StyledExchangeSummaryContainer } from './ExchangeSummary.styles';
import { ActionContent } from 'pages/BookingDetails/Notes/NotesAndHistorySection/HistoryDetails/HistoryDetail/HistoryDetail.styles';

const ExchangeSummary = ({ outboundTickets = [], inboundTickets = [], isMiceGroup = false, isAllJourneysSelected = false }) => {
  const [isOpen, setOpen] = useState(true);
  const [shouldTransition, setShouldTransition] = useState(false);
  const [height, setHeight] = useState(0);

  const onToggle = () => setOpen(!isOpen);
  const contentEl = useRef();

  useEffect(() => {
    if (!contentEl.current || height !== 0) {
      return;
    }

    const computedHeight = window.getComputedStyle(contentEl.current).height;
    setHeight(computedHeight);

    setOpen(false);
    setShouldTransition(true);
  }, [contentEl, height]);

  if (!outboundTickets.length && !inboundTickets.length) return null;

  return (
    <StyledJourneySummary data-cy="exchange-summary">
      <ExchangeSummaryHeader
        onClick={onToggle}
        open={isOpen}
        outbound={outboundTickets.map(({ products }) => products).flat()}
        inbound={inboundTickets.map(({ products }) => products).flat()}
        isAllJourneysSelected={isAllJourneysSelected}
      />

      <ActionContent height={height} shouldTransition={shouldTransition} isExpanded={isOpen} ref={contentEl}>
        <StyledExchangeSummaryContainer>
          <div>
            {outboundTickets.map(
              ({ products, absProducts, ...rest }) =>
                products?.length > 0 && (
                  <ExchangeSummaryContainer
                    key={`summary-${rest.trainNumber}_${rest.timing?.departs}_${rest.timing?.arrives}`}
                    journey={products}
                    absProducts={absProducts}
                    isMiceGroup={isMiceGroup}
                    {...rest}
                  />
                )
            )}
          </div>
          <div>
            {inboundTickets.map(
              ({ products, absProducts, ...rest }) =>
                products?.length > 0 && (
                  <ExchangeSummaryContainer
                    key={`summary-${rest.trainNumber}_${rest.timing?.departs}_${rest.timing?.arrives}`}
                    journey={products}
                    absProducts={absProducts}
                    direction={'inbound'}
                    isMiceGroup={isMiceGroup}
                    {...rest}
                  />
                )
            )}
          </div>
        </StyledExchangeSummaryContainer>
      </ActionContent>
    </StyledJourneySummary>
  );
};

ExchangeSummary.propTypes = {
  outboundTickets: PropTypes.arrayOf(legShape),
  inboundTickets: PropTypes.arrayOf(legShape),
  isMiceGroup: PropTypes.bool,
  isAllJourneysSelected: PropTypes.bool
};

export default ExchangeSummary;
